import { createSlice } from '@reduxjs/toolkit';

export const homeSlice = createSlice({
  name: 'home',
  initialState: {
    listings: [],
    bounds: null
  },
  reducers: {
    setListings: (state, action) => {
      state.listings = action.payload;
    },
    setBounds: (state, action) => {
      state.bounds = action.payload;
    }
  }
});

export const { setListings, setBounds } = homeSlice.actions;
export default homeSlice.reducer;
